export type Service = {
  id: string
  title: string
  description: string
  features: string[]
  cta: string
  icon: 'life' | 'health' | 'supplemental'
}

export const services: Service[] = [
  {
    id: 'vida',
    icon: 'life',
    title: 'SEGUROS DE VIDA',
    description:
      'Protege económicamente a quienes más quieres y explora alternativas de protección que puedan acompañarte durante diferentes etapas de tu vida.',
    features: [
      'Protección familiar',
      'Beneficios en vida, según la póliza',
      'Diferentes tipos de productos',
      'Opciones según elegibilidad y necesidades',
    ],
    cta: 'QUIERO SABER MÁS',
  },
  {
    id: 'salud',
    icon: 'health',
    title: 'SEGUROS DE SALUD',
    description:
      'Explora alternativas de cobertura médica para ti y tu familia, considerando tus necesidades, presupuesto y situación particular.',
    features: [
      'Opciones individuales',
      'Opciones familiares',
      'Diferentes compañías',
      'Orientación personalizada',
    ],
    cta: 'EXPLORAR OPCIONES',
  },
  {
    id: 'suplementales',
    icon: 'supplemental',
    title: 'SEGUROS SUPLEMENTALES',
    description:
      'Complementa tu protección con alternativas diseñadas para determinados eventos o situaciones que pueden generar gastos adicionales.',
    features: [
      'Protección complementaria',
      'Diferentes alternativas',
      'Opciones según necesidad',
      'Soluciones adicionales',
    ],
    cta: 'CONOCER OPCIONES',
  },
]

export const companyTabs = [
  {
    id: 'vida',
    label: 'VIDA',
    companies: [
      'National Life Group',
      'Americo',
      'American Amicable',
      'Mutual of Omaha',
      'Ethos',
      'Senior Life',
      'F&G',
      'Transamerica',
      'Foresters',
      'Corebridge',
      'Ameritas',
    ],
  },
  {
    id: 'salud',
    label: 'SALUD',
    companies: [
      'Oscar',
      'Aetna',
      'Ambetter',
      'Molina',
      'UnitedHealthcare',
      'AvMed',
    ],
  },
  {
    id: 'suplementales',
    label: 'SUPLEMENTALES',
    companies: ['Combined', 'Manhattan Life', 'Cigna'],
  },
]

export const articles = [
  {
    title: '¿Por qué considerar un seguro de vida?',
    description:
      'Conoce algunos de los factores que pueden hacer que una estrategia de protección sea importante para una familia.',
    topic: 'VIDA',
  },
  {
    title: '¿Qué debo considerar al elegir un seguro de salud?',
    description:
      'Conoce algunos aspectos importantes que puedes evaluar antes de elegir una cobertura.',
    topic: 'SALUD',
  },
  {
    title: '¿Qué son los seguros suplementales?',
    description:
      'Aprende cómo pueden complementar determinadas necesidades de protección.',
    topic: 'SUPLEMENTALES',
  },
]

export type Testimonial = {
  initials: string
  quote: string
  name: string
  image?: string
  imageAlt?: string
}

export const testimonials: Testimonial[] = [
  {
    initials: 'SI',
    quote: '¡Gracias Andreita! Tú hiciste todo.',
    name: 'Sandra I.',
    image: 'https://cdn.magicpatterns.com/uploads/4j3EnJQvjH2b7yAqeHQL3s/IMG_9661_2.jpg',
    imageAlt:
      'Captura de una conversación de WhatsApp en la que una clienta agradece a Andrea por acompañarla en el proceso',
  },
  { initials: 'CV', quote: '[Agregar aquí testimonio real del cliente]', name: 'Cliente verificado' },
  { initials: 'CV', quote: '[Agregar aquí testimonio real del cliente]', name: 'Cliente verificado' },
]

export const whyItems = [
  { n: '01', title: 'ESCUCHAMOS', text: 'Primero entendemos tu situación, necesidades y objetivos.' },
  { n: '02', title: 'ANALIZAMOS', text: 'Revisamos las alternativas disponibles para tu situación.' },
  { n: '03', title: 'EXPLICAMOS', text: 'Te explicamos las opciones de forma clara y sencilla.' },
  { n: '04', title: 'DECIDES', text: 'La decisión final siempre es tuya.' },
]

export const processSteps = [
  { n: '01', title: 'CONVERSAMOS', text: 'Conocemos tu situación y lo que quieres proteger.' },
  { n: '02', title: 'ANALIZAMOS', text: 'Exploramos las alternativas disponibles.' },
  { n: '03', title: 'EXPLICAMOS', text: 'Te explico las opciones y sus características.' },
  { n: '04', title: 'DECIDES', text: 'Tomas tu decisión con la información necesaria.' },
]
